import axios from 'axios'
import type { AxiosRequestConfig, AxiosResponse } from 'axios'

let auth_token: string = (window as any).auth_token || ''

if (typeof auth_token != 'undefined' && auth_token !== '') {
  try {
    auth_token = JSON.parse(atob(auth_token))
  } catch (e) {
    console.error('Failed to parse auth_token:', e)
  }
}

axios.defaults.withCredentials = true
axios.defaults.headers.common['Nonce'] = auth_token

interface RequestParams {
  endpoint: string
  params?: any
  options?: AxiosRequestConfig,
  baseURL?: string
}

const axiosApi = {
  post: ({ endpoint, params, options = {}, baseURL }: RequestParams): Promise<AxiosResponse> => {
    endpoint =  (baseURL ?? (import.meta.env.VITE_VUE_APP_API_SERVER || '')) + endpoint
    return axios.post(endpoint, params, options).then((res) => {
      return res
    })
  },
  get: ({ endpoint, params, options = {}, baseURL }: RequestParams): Promise<AxiosResponse> => {
    endpoint = (baseURL ?? (import.meta.env.VITE_VUE_APP_API_SERVER || '')) + endpoint
    return axios.get(endpoint, { params, ...options }).then((res) => {
      return res
    })
  },
  delete: ({ endpoint,  options = {}, baseURL }: RequestParams): Promise<AxiosResponse> => {
    endpoint = (baseURL ?? (import.meta.env.VITE_VUE_APP_API_SERVER || '')) + endpoint
    return axios.delete(endpoint, options).then((res) => {
      return res
    })
  }
}

export const debounce = <T extends (...args: any[]) => void>(
  fn: T,
  delay: number
): ((...args: Parameters<T>) => void) => {
  let timeoutID: number | null = null
  return function (this: any, ...args: Parameters<T>) {
    if (timeoutID !== null) {
      clearTimeout(timeoutID)
    }
    timeoutID = window.setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

export const makeFormData = (params: any): FormData => {
  let bodyFormData = new FormData()
  for (const [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        bodyFormData.append(`${key}[]`, String(item))
      })
    } else {
      bodyFormData.append(key, String(value))
    }
  }
  return bodyFormData
}


export const makePostApiCall = (endpoint: string, params: any, options:any = {}, fileUpload:boolean = false): Promise<AxiosResponse> => {
  return axiosApi.post({
    endpoint,
    params: fileUpload ? params : makeFormData(params),
    options: {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...options.headers, // merge with any user-provided headers
      },
      ...options, // merge any other options passed
    }
  })
}

export default axiosApi
